/** @flow */

import React from "react";
import config from "@config";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  DatePicker,
  Icon,
  ComboBox,
} from "@components";
import type { ManualReferralTaskData } from "@modules/shared/reducer/employee-events/types";
import type { ReferralQuestionAnswerType } from "@modules/shared/reducer/types";

type Props = $Exact<{
  data: ManualReferralTaskData,
  toggleModal?: Function,
  t: Function,
}>;

function ManualReferralTaskModal(props: Props) {
  function generateQuestionField(qa: ReferralQuestionAnswerType) {
    const answer = qa.answer && qa.answer.value;

    // Don't know how to check this modal. Need help from qa
    switch (qa.question.questionType) {
      case "CONFIRMATION":
        return <div />;

      case "FREE_TEXT":
        return <Input value={answer} disabled />;

      case "DATE_PICK":
        return <DatePicker disabled dateFormat={config.dateTimeFormat} value={answer} />;

      case "MULTI_SELECT":
        return (
          <ComboBox
            disabled
            isMulti
            value={
              answer && answer.map
                ? answer.map(val => {
                    return { value: val, label: val };
                  })
                : []
            }
            options={qa.question.selectableValues}
          />
        );

      case "SINGLE_SELECT":
        return (
          <ComboBox
            disabled
            value={{
              value: answer,
              label: answer,
            }}
            options={[qa.question.selectableValues]}
          />
        );
    }

    return true;
  }

  function generateQuestions() {
    return props.data.questionAnswers.map((qa: Object) => {
      return (
        <div key={qa.question.id} className={"mb-4"}>
          {qa.question.questionText}
          {qa.question.isMandatory && (
            <Icon icon="asterisk" size="xs" className="text-warning ml-2" />
          )}
          {generateQuestionField(qa)}
        </div>
      );
    });
  }

  return (
    <Modal className={"referral-decision-modal"}>
      <ModalHeader toggle={props.toggleModal}>
        {props.t("ACTIVITY_HISTORY_ITEM_TITLE", {
          id: props.data.id,
          type: props.t("MANUAL_REFERRAL"),
        })}
      </ModalHeader>

      <ModalBody>
        <div className={"mb-4 font-weight-bold"}>
          {props.t("SUPPLIER_NAME")}
          <Input disabled={true} value={props.data.supplierName} />
        </div>
        <div className={"mb-4 font-weight-bold"}>
          {props.t("REASON_FOR_REFERRAL")}
          <ComboBox
            disabled
            value={{ value: props.data.reason.reason, label: props.data.reason.reason }}
            options={[{ value: props.data.reason.reason, label: props.data.reason.reason }]}
          />
        </div>

        <div className={"mb-4 font-weight-bold"}>{props.t("Referral questions")}</div>
        {generateQuestions()}
      </ModalBody>
      <ModalFooter>
        <Button onClick={props.toggleModal}>{props.t("CANCEL")}</Button>
      </ModalFooter>
    </Modal>
  );
}

export default ManualReferralTaskModal;
